import SortOptions, { TYPES, ORDERS } from './SortOptions.component';

export default SortOptions;
export { TYPES, ORDERS };
